import { Button, Divider, Flex, Icon, Image, Text } from '@chakra-ui/react';
import {
  BookHeartIcon,
  HandshakeIcon,
  MapPinIcon,
  PlusIcon,
} from 'lucide-react';
import offerScorecardImage from '~/apps/consumer/images/offerScorecard.png';
import offerScorecardMobileImage from '~/apps/consumer/images/offerScorecardMobile.png';
import { useIsMobile } from '~/common/hooks/useIsMobile';

export const OfferScorecardsNoData = ({ onClick }: { onClick: () => void }) => {
  const isMobile = useIsMobile();

  return (
    <Flex alignItems="center" direction="column" gap={4} minHeight={0}>
      <Flex direction="column" gap={0} height="70%">
        <Image
          height="100%"
          src={isMobile ? offerScorecardMobileImage : offerScorecardImage}
          width="auto"
        />
        <Divider />
      </Flex>
      <Flex
        alignItems="center"
        direction={isMobile ? 'column' : 'row'}
        gap={isMobile ? 4 : 10}
        justifyContent="space-between"
        width={isMobile ? '80%' : '100%'}
      >
        <Flex
          alignItems="center"
          direction="column"
          justifyContent="center"
          width="300px"
        >
          <Icon as={MapPinIcon} boxSize={6} color="cyan.500" />
          <Text fontSize="lg" fontWeight="medium">
            Create an AI-powered CMA
          </Text>
          <Text color="whiteAlpha.700">Automated and fully customizable</Text>
        </Flex>
        <Flex
          alignItems="center"
          direction="column"
          justifyContent="center"
          width="300px"
        >
          <Icon as={HandshakeIcon} boxSize={6} color="cyan.500" />
          <Text fontSize="lg" fontWeight="medium">
            Compare key terms to market data
          </Text>
          <Text color="whiteAlpha.700">
            Real-time feedback on your offer terms
          </Text>
        </Flex>
        <Flex
          alignItems="center"
          direction="column"
          justifyContent="center"
          width="300px"
        >
          <Icon as={BookHeartIcon} boxSize={6} color="cyan.500" />
          <Text fontSize="lg" fontWeight="medium">
            Share a beautiful report with your buyer
          </Text>
          <Text color="whiteAlpha.700">
            Communicate and justify your offer with ease
          </Text>
        </Flex>
      </Flex>
      <Flex>
        <Button
          leftIcon={<PlusIcon size={16} />}
          size="sm"
          width="100%"
          onClick={onClick}
        >
          New Offer Scorecard
        </Button>
      </Flex>
    </Flex>
  );
};
